import { render, staticRenderFns } from "./RoleAssignmentRow.vue?vue&type=template&id=09c48c0a&scoped=true&"
import script from "./RoleAssignmentRow.vue?vue&type=script&lang=js&"
export * from "./RoleAssignmentRow.vue?vue&type=script&lang=js&"
import style0 from "./RoleAssignmentRow.vue?vue&type=style&index=0&id=09c48c0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c48c0a",
  null
  
)

export default component.exports